import React, { useState, useEffect, useRef } from "react";
import { Button, Pagination } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import "./divisionWiseTable.scss";
import { CSVLink } from "react-csv";

const csvHeaders = [
	{ label: "L1", key: "l1" },
	{ label: "L2", key: "l2" },
	{ label: "L3", key: "l3" },
	{ label: "Item ID", key: "sku" },
	{ label: "Part Number", key: "MANUFACTURER_PART_NO_MFRPN" },
	{ label: "Supplier Name", key: "master_vendor_name" },
	{ label: "Project Type", key: "project_flag" },
	{ label: "District", key: "district" },
	{ label: "Sales Office", key: "SALES_OFFICE_VKBUR" },
	{ label: "Customer Market", key: "customerMarket" },
	{ label: "Customer Sub-Market", key: "customerSubMarket" },
	{ label: "Customer Size", key: "customerSize" },
	{ label: "Stratification Quadrant", key: "stratification" },
	{ label: "Peer Customer Group Name", key: "peerGroupName" },
	{ label: "Customer ID", key: "customer" },
	{ label: "Customer Name", key: "customerName" },
	{ label: "Total Sales", key: "revenue" },
	{ label: "Volume", key: "quantity" },
	{ label: "Current Price ($)", key: "price" },
	{ label: "Target Price ($)", key: "peer_price" },
	{ label: "Floor Price ($)", key: "FloorPrice" },
	{ label: "Total Transactions", key: "totalTransactions" },
	{ label: "# Transactions > Target", key: "transactionsGreaterThanTarget" },
	{ label: "# Transactions < Floor", key: "transactionslessThanFloor" },
	{ label: "Opportunity ($)", key: "projectedOpportunity" },
];

const CustomerSummaryTable = (props: any) => {
	const {
		totalOppAndRev,
		exportData,
		selectedFilters,
		extraFilters,
		ExportFlag,
	} = props;
	const [limit, setLimit] = React.useState(10);
	const [selectedItem, setSelectedItem] = useState<any>(null);
	const [selectedDistrict, setSelectedDistrict] = useState<any>(null);
	const [selectedGroup, setSelectedGroup] = useState<any>(null);
	const [selectedCustomerList, setSelectedCustomerList] = useState<any>(null);

	const exportFullRef = useRef<any>(null);

	const removeLeadingZero = (n: any) => {
		let newStr = n.replace(/^0+/, "");
		return newStr;
	};

	const exportExcel = () => {
		// props.updateExportFlag(true);
		props?.getExportData();
	};

	useEffect(() => {
		console.log(exportData?.length, ExportFlag, "export");
		if (exportData?.length !== 0 && ExportFlag) {
			props?.updatesetExportFlag();
			exportFullRef?.current?.link.click();
		}
	}, [exportData, ExportFlag]);

	return (
		<>
			<table className="common-table-ui !h-[80%]">
				<thead>
					<tr>
						<th>Item ID</th>
						<th>Part Number</th>
						<th>Item Description</th>
						<th>Supplier</th>
						{selectedItem && <th>District</th>}
						{selectedDistrict && (
							<th className="w-[50vw]">
								Peer Customer Group Name
							</th>
						)}
						{selectedGroup && (
							<>
								<th>Customer ID</th>
								<th>Customer Name</th>
							</>
						)}
						<th>Total Sales ($)</th>
						<th>Opportunity ($)</th>
					</tr>
				</thead>
				<tbody>
					{props.data.length > 0 ? (
						Array.isArray(props.data) &&
						props?.data?.map((d: any, index: any) => {
							return (
								<React.Fragment key={d.sku + "_" + index}>
									<tr
										key={d.sku}
										// onClick={() => {
										//   setSelectedItem(d.id);
										// }}
										className={`${
											selectedItem !== d.sku
												? ""
												: "selected-row"
										}`}
									>
										<td>
											<div className="flex">
												{selectedItem === d.sku ? (
													<MinusRoundIcon
														className="plusIcon"
														onClick={() => {
															setSelectedItem(
																null
															);
															props.updateSelectedCustomerList(
																null
															);
															setSelectedGroup(
																null
															);
															setSelectedDistrict(
																null
															);
															props.updateSelectedCustomer(
																null
															);
														}}
													/>
												) : (
													<PlusRoundIcon
														className="plusIcon"
														onClick={() => {
															props.updateDivisionList(
																d.sku,
																d.master_vendor_name
															);
															setSelectedItem(
																d.sku
															);
															setSelectedDistrict(
																null
															);
															props.updateSelectedCustomerList(
																null
															);
															setSelectedGroup(
																null
															);
															props.updateSelectedCustomer(
																null
															);
														}}
													/>
												)}
												<div>
													{removeLeadingZero(d.sku)}
												</div>
											</div>
										</td>
										<td>{d?.MANUFACTURER_PART_NO_MFRPN}</td>
										<td>{d.itemDesc}</td>
										<td>{d.master_vendor_name}</td>
										{selectedItem && <td></td>}
										{selectedDistrict && <td></td>}
										{selectedGroup && (
											<>
												<td></td>
												<td></td>
											</>
										)}
										<td>
											{numberFormatter(d.revenue, 0, "$")}
										</td>
										<td>
											{numberFormatter(
												d.lostOpportunity,
												0,
												"$"
											)}
										</td>
									</tr>
									{selectedItem === d.sku &&
										d?.divisionList &&
										(d?.divisionList).map(
											(item: any, dIndex: any) => {
												return (
													<>
														<tr
															className={`${
																selectedDistrict !==
																`${d.sku}_${item.district}`
																	? ""
																	: "selected-row"
															}`}
															key={`${d.sku}_${item.district}`}
														>
															<td></td>
															<td></td>
															<td></td>
															<td></td>
															<td>
																<div className="flex">
																	{selectedDistrict ===
																	`${d.sku}_${item.district}` ? (
																		<MinusRoundIcon
																			className="plusIcon"
																			onClick={() => {
																				setSelectedDistrict(
																					null
																				);
																				props.updateSelectedCustomerList(
																					null
																				);
																				setSelectedGroup(
																					null
																				);
																				props.updateSelectedCustomer(
																					null
																				);
																			}}
																		/>
																	) : (
																		<PlusRoundIcon
																			className="plusIcon"
																			onClick={() => {
																				setSelectedDistrict(
																					`${d.sku}_${item.district}`
																				);
																				props.updateSelectedCustomerList(
																					null
																				);
																				setSelectedGroup(
																					null
																				);
																				props.updateSelectedCustomer(
																					null
																				);
																			}}
																		/>
																	)}
																	<div>
																		{
																			item.district
																		}
																	</div>
																</div>
															</td>
															{selectedDistrict && (
																<td></td>
															)}
															{selectedGroup && (
																<>
																	<td></td>
																	<td></td>
																</>
															)}
															<td>
																{numberFormatter(
																	item.revenue,
																	0,
																	"$"
																)}
															</td>
															<td>
																{numberFormatter(
																	item.lostOpportunity,
																	0,
																	"$"
																)}
															</td>
														</tr>
														{selectedDistrict ===
															`${d.sku}_${item.district}` &&
															item.peerData.map(
																(
																	lis: any,
																	lIndex: any
																) => {
																	return (
																		<>
																			<tr
																				key={`${lis.peerGroupName}_${lIndex}`}
																				className={` ${
																					selectedCustomerList !==
																					`${lis.peerGroupName}_${lIndex}`
																						? " "
																						: "selected-row"
																				}`}
																			>
																				<td></td>
																				<td></td>
																				<td></td>
																				<td></td>
																				<td></td>
																				<td>
																					<div
																						className="flex"
																						style={{
																							alignItems:
																								"center",
																						}}
																					>
																						<span className="icon-container">
																							{selectedGroup ===
																							`${lis.peerGroupName}_${lIndex}` ? (
																								<MinusRoundIcon
																									className="plusIcon"
																									style={{
																										fontSize:
																											"0.9rem",
																									}}
																									onClick={() => {
																										setSelectedGroup(
																											null
																										);
																										props.updateSelectedCustomer(
																											null
																										);
																										setSelectedCustomerList(
																											null
																										);
																									}}
																								/>
																							) : (
																								<PlusRoundIcon
																									className="plusIcon"
																									style={{
																										fontSize:
																											"0.9rem",
																									}}
																									onClick={() => {
																										setSelectedCustomerList(
																											`${lis.peerGroupName}_${lIndex}`
																										);
																										setSelectedGroup(
																											`${lis.peerGroupName}_${lIndex}`
																										);
																										props.updateCustomerList(
																											d.sku,
																											d.master_vendor_name,
																											item.district,
																											lis.peerGroupName
																										);
																									}}
																								/>
																							)}
																						</span>
																						<div className="peer-group-name">
																							{
																								lis.peerGroupName
																							}
																						</div>
																					</div>
																				</td>
																				{selectedGroup && (
																					<>
																						<td></td>
																						<td></td>
																					</>
																				)}
																				<td>
																					{numberFormatter(
																						lis.revenue,
																						0,
																						"$"
																					)}
																				</td>
																				<td>
																					{numberFormatter(
																						lis.lostOpportunity,
																						0,
																						"$"
																					)}
																				</td>
																			</tr>
																			{selectedGroup ===
																				`${lis.peerGroupName}_${lIndex}` &&
																				lis.customerData &&
																				lis.customerData.map(
																					(
																						cus: any,
																						cIndex: any
																					) => {
																						return (
																							<>
																								<tr
																									key={`${cus.customer}_${cIndex}`}
																									className={`cursor-pointer ${
																										props.selectedCustomer ===
																										`${cus.customer}_${cIndex}`
																											? "selected-row"
																											: ""
																									} `}
																									onClick={() => {
																										props.updateSelectedCustomer(
																											`${cus.customer}_${cIndex}`
																										);
																										props.updateSelectedCustomerList(
																											{
																												itemId: d.sku,
																												district:
																													item.district,
																												peerGroupName:
																													lis.peerGroupName,
																												master_vendor_name:
																													d.master_vendor_name,
																												customer:
																													cus.customer,
																											}
																										);
																									}}
																								>
																									<td></td>
																									<td></td>
																									<td></td>
																									<td></td>
																									<td></td>
																									<td></td>
																									<td>
																										{removeLeadingZero(
																											cus.customer
																										)}
																									</td>
																									<td>
																										{
																											cus.customerName
																										}
																									</td>
																									<td>
																										{numberFormatter(
																											cus.revenue,
																											0,
																											"$"
																										)}
																									</td>
																									<td>
																										{numberFormatter(
																											cus.lostOpportunity,
																											0,
																											"$"
																										)}
																									</td>
																								</tr>
																							</>
																						);
																					}
																				)}
																		</>
																	);
																}
															)}
													</>
												);
											}
										)}
								</React.Fragment>
							);
						})
					) : (
						<tr>
							<td
								colSpan={6}
								className="text-mainGreen"
								style={{ textAlign: "center" }}
							>
								{" "}
								No Data Available
							</td>
						</tr>
					)}
					<tr className="total-row">
						<td className="center">Total</td>
						<td></td>
						<td></td>
						<td></td>
						{selectedItem && <td></td>}
						{selectedDistrict && <td></td>}
						{selectedGroup && (
							<>
								<td></td>
								<td></td>
							</>
						)}
						<td>
							{numberFormatter(
								totalOppAndRev[0]?.revenue,
								0,
								"$"
							)}
						</td>
						<td>
							{numberFormatter(
								totalOppAndRev[0]?.lostOpportunity,
								0,
								"$"
							)}
						</td>
					</tr>
				</tbody>
			</table>
			<div className="pagination-components h-[10%]">
				{selectedFilters?.l3?.length > 0 &&
					extraFilters?.district?.length > 0 && (
						<div>
							<button
								className="text-[0.7vw] bg-green-700 px-2 py-1 rounded-md"
								onClick={exportExcel}
							>
								Export Excel
							</button>
							<CSVLink
								ref={exportFullRef}
								data={exportData}
								headers={csvHeaders}
								filename="pricing.csv"
								className="hidden"
								target="_blank"
							>
								{" "}
							</CSVLink>
						</div>
					)}
				<Pagination
					prev
					next
					first
					last
					ellipsis
					boundaryLinks
					maxButtons={5}
					layout={["-", "pager", "skip"]}
					total={props.count}
					limit={limit}
					activePage={props.pageNumber}
					onChangePage={(e) => {
						props.updatePageNumber(e);
					}}
				/>
			</div>
		</>
	);
};
export default CustomerSummaryTable;
